import { ElMessage } from "element-plus";
import WarningIcon from "@/components/icon/WarningIcon.vue";
import SuccessIcon from "@/components/icon/SuccessIcon.vue";
import loadingIcon from "@/components/icon/loading.vue";
import "@/assets/styles/element/message.scss"
import { h } from 'vue'

/**
 * 错误的弹窗 设置弹窗消失默认时长3秒
 * @param {错误信息} message 
 * @param {距离顶部的距离默认是120px} offset
 */
export function messageError(message, offset=120) {
  ElMessage({
    message: message,
    grouping: false,
    type: 'error',
    offset: offset,
    icon: WarningIcon,
    customClass: 'error_custom',
  })
}

/**
 * 
 * @param {错误信息} message 
 * @param {设置弹窗消失时长} duration 
 */

export function messageErrorDuration(message, duration) {
  ElMessage({
    message: message,
    grouping: false,
    duration: duration,
    type: 'error',
    offset: 5,
    icon: WarningIcon,
    customClass: 'error_custom',
  })
}
/**
 * 设置成功信息默认3s消失
 * @param {成功信息} message 
 * @param {距离顶部的距离默认是120px} offset
 */
export function messageSuccess(message, offset=120) {
  ElMessage({
    message: message,
    grouping: false,
    type: 'success',
    offset: offset,
    icon: SuccessIcon,
    customClass: 'success_custom',
  })
}

/**
 * 设置成功信息toast
 * @param {成功信息} message 
 * @param {设置弹窗消失时长} duration 
 */
export function messageSuccessDuration(message, duration) {
  ElMessage({
    message: message,
    grouping: false,
    type: 'success',
    duration: duration,
    offset: 5,
    icon: SuccessIcon,
    customClass: 'success_custom'
  })
}


/**
 * 设置加载信息默认3s消失
 * @param {成功信息} message 
 * @param {距离顶部的距离默认是120px} offset
 */
export function messageLoading(message, offset=120) {
  return ElMessage({
    message: message,
    grouping: false,
    type: 'success',
    offset: offset,
    icon: loadingIcon,
    customClass: 'success_custom',
  })
}

/**
 * 设置加载toast
 * @param {true:开启，false:关闭} message 
 * 
 */

// let messageInstance = null;
// export function messageLoading(type) {
//   console.log('messageInstance',messageInstance)
//   if(type){
//     messageInstance = ElMessage({
//       message: '正在生成预览',
//       grouping: true,
//       type: 'success',
//       duration: 0,
//       offset: 40,
//       icon: loadingIcon,
//       customClass: 'success_custom'
//     })
//   }else{
//     if(messageInstance){
//       messageInstance.close()
//       messageInstance = null;
//     } 
//   }
// }

let subtitleInstance = null;
export function notifySubtitleChange(msg, refreshCb) {
  if(subtitleInstance){
    subtitleInstance.close()
    subtitleInstance = null;
  }
  if (!msg) {
    return
  }
  subtitleInstance = ElMessage({
    message: h('div', { style: 'line-height: 1;color: #212429; font-size: 14px; width:342px;margin-top:2px', }, [
      h('span', null, msg),
      h('span', { style: 'color: #2A94FFFF;margin-left:16px;cursor: pointer;', onClick(event) {
          if (subtitleInstance) {
            subtitleInstance.close()
            subtitleInstance = null;
          }
          refreshCb && refreshCb();
        }}, '更新',),
    ]),
    grouping: true,
      type: 'success',
      duration: 0,
      offset: 120,
      icon: WarningIcon,
      customClass: 'error_custom',
      showClose: true,
  })
}
